var map = {
	"./call-chat--mobile.jpg": 787,
	"./call-chat.jpg": 1016,
	"./personal-account--mobile.jpg": 788,
	"./personal-account.jpg": 1017,
	"./phone--mobile.jpg": 789,
	"./phone.jpg": 1018
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3075;